import React from 'react'
import orderBy from 'lodash/orderBy'
import { connect } from 'react-redux'
import { fetchPages, deserializePage } from 'supporticon/api/pages'
import { selectAPIParams } from '../../../store/site'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Filter from 'constructicon/filter'
import Loading from '../../ui/Loading'
import ProgressTiles from '../../ui/ProgressTiles'
import Section from '../../ui/Section'

class PageProgressTiles extends React.Component {
  constructor () {
    super()
    this.state = {
      filter: null,
      pages: [],
      status: 'fetching'
    }
  }

  sortPages (pages) {
    const { order, sort } = this.props

    switch (order) {
      case 'amount':
        return orderBy(pages, ['raised'], [sort])
      case 'target':
        return orderBy(pages, ['target'], [sort])
      case 'date':
        return orderBy(pages, ['campaignDate'], [sort])
      case 'id':
        return orderBy(pages, ['id'], [sort])
      default:
        return orderBy(pages, ['name'], [sort])
    }
  }

  componentDidMount () {
    const {
      apiParams,
      campaignOverride,
      limit
    } = this.props

    const params = {
      ...apiParams,
      allPages: true,
      campaign: campaignOverride || apiParams.campaign,
      limit: limit || 20
    }

    fetchPages(params)
      .then(pages => pages.map(deserializePage))
      .then(pages => this.sortPages(pages))
      .then(pages => this.setState({ pages, status: 'fetched' }))
      .catch(error => {
        this.setState({ status: 'failed' })
        return Promise.reject(error)
      })
  }

  render () {
    const {
      action,
      alignment,
      backgroundImage,
      background,
      barColor,
      buttonBackground,
      buttonForeground,
      copy,
      copyAlignment,
      foreground,
      fundedAction,
      includeFilter,
      metric,
      size,
      spacing,
      subtitle,
      title,
      titleForeground,
      titleSize
    } = this.props

    const {
      filter,
      pages,
      status
    } = this.state

    const data = pages
      .map(page => {
        const isFunded = page.raised >= page.target
        const isDisabled = isFunded && fundedAction === 'disable'

        return {
          ...page,
          raised: page.raised,
          target: page.target,
          actions: [{
            to: action === 'view'
              ? isDisabled ? '' : page.url
              : isDisabled ? '' : page.donationUrl,
            label: action === 'view'
              ? isDisabled ? 'Project Funded' : 'View Project'
              : isDisabled ? 'Project Funded' : 'Donate Now'
          }]
        }
      })
      .filter(page => {
        return filter
          ? page.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1
          : true
      })

    return (
      <Section
        alignment={alignment}
        backgroundImage={backgroundImage}
        background={background}
        foreground={foreground}
        size={size}
        spacing={spacing}>

        <Content
          copy={copy}
          copyAlignment={copyAlignment}
          subtitle={subtitle}
          title={title}
          titleForeground={titleForeground}>

          {status === 'fetching' && <Loading />}
          {status === 'failed' && <Error>There was an error loading pages.</Error>}
          {status === 'fetched' && (
            <div>
              {includeFilter === 'yes' && (
                <Filter
                  onChange={filter => this.setState({ filter })}
                />
              )}
              <ProgressTiles
                action={action}
                barColor={barColor}
                buttonBackground={buttonBackground}
                buttonForeground={buttonForeground}
                data={data}
                metric={metric}
                titleForeground={titleForeground}
                titleSize={titleSize}
              />
            </div>
          )}

        </Content>
      </Section>
    )
  }
}

const mapState = (state) => ({
  ...selectAPIParams(state)
})

export default connect(mapState)(PageProgressTiles)



// WEBPACK FOOTER //
// ./components/slices/PageProgressTiles/index.js